<div class="position-relative">
  <div class="d-flex" style="position: absolute; top: 5px; right: 0px;z-index: 21">
    <asax-sky-view-aladin-vo class="mx-1"
                             [voServicesOverlays]="voServiceOverlays"
                             (outAddVoService)="onOutAddService($event)">
    </asax-sky-view-aladin-vo>
    <asax-sky-view-aladin-configuration class="mx-1"
                                        (outDisplayCells)="onOutDisplayCells($event)"
                                        (outDisplayFootprints)="onOutDisplayFootprints($event)"
                                        (outDisplaySkyObjects)="onOutDisplaySkyObjects($event)">
    </asax-sky-view-aladin-configuration>
  </div>
  <asax-sky-view-aladin-sky [height]="height"
                            [width]="width"

                            [raDecFov]="raDecFov | async"

                            [baseImage]="baseImage | async"
                            [overlayImage]="overlayImage | async"
                            [alpha]="alpha | async"

                            [footprints]="areFootprintsVisible ? (footprints | async) : null"
                            [skyObjects]="skyObjects | async"

                            [cells]="cells | async"

                            [sourceNameSearchRadius]="sourceNameSearchRadius | async"
                            [raDecSearchRadius]="raDecSearchRadius | async"

                            [footprintsRowHovered]="footprintsRowHovered | async"

                            [addVoServiceOverlay]="voServiceAdded | async"
                            [removeVoServiceOverlay]="voServiceRemoved | async"

                            (outAladinSearchPolygon)="onOutAladinSearchPolygon($event)"
                            (outAladinFov)="onOutAladinFov($event)"
                            (outAladinMouseMove)="onOutAladinMouseMove($event)"
                            (outContextmenu)="onOutContextmenu($event)"
                            (outMouseClick)="onOutMouseClick($event)"

                            (outAladinSkyObjectHovered)="onOutAladinSkyObjectHovered($event)"
                            (outAladinFootprintClicked)="onOutAladinFootprintClicked($event)"
                            (outAladinFootprintHovered)="onOutAladinFootprintHovered($event)"
                            (outAladinSearchRadiusHovered)="onOutAladinSearchRadiusHovered($event)">
  </asax-sky-view-aladin-sky>
  <asax-sky-view-aladin-sky-layers-container [height]="height" [width]="width"></asax-sky-view-aladin-sky-layers-container>
  <asax-sky-view-aladin-popover-container></asax-sky-view-aladin-popover-container>
</div>
